module.exports = __webpack_public_path__ + "static/img/home_icon4.f243b9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/home_icon4.jpg
// module id = qX16
// module chunks = 21